import { supabase } from './supabaseClient';

export const CREW_MEDIA_BUCKET = 'crew-private-assets';
export const CREW_MEDIA_PREFIX = `storage://${CREW_MEDIA_BUCKET}/`;
const TYPES = new Set(['image/jpeg', 'image/png', 'image/webp', 'image/gif', 'image/heic', 'image/heif', 'video/mp4', 'video/quicktime', 'video/webm']);
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export async function uploadCrewMedia(file: File, staffId: string, shiftId?: string, setup = false) {
  if (!UUID.test(staffId) || (shiftId !== undefined && !UUID.test(shiftId))) throw new Error('Invalid media destination');
  if (!TYPES.has(file.type) || file.size > 50 * 1024 * 1024 || file.size === 0) throw new Error('Use a supported image/video up to 50 MB');
  if ((!shiftId || setup) && !file.type.startsWith('image/')) throw new Error('Please select an image');
  const extension: Record<string, string> = { 'image/jpeg': 'jpg', 'image/png': 'png', 'image/webp': 'webp', 'image/gif': 'gif', 'image/heic': 'heic', 'image/heif': 'heif', 'video/mp4': 'mp4', 'video/quicktime': 'mov', 'video/webm': 'webm' };
  const suffix = `${crypto.randomUUID()}.${extension[file.type]}`;
  const filename = `${setup ? 'SETUP_' : ''}${staffId}_${suffix}`;
  const path = shiftId ? `shift_media/${shiftId}/${filename}` : `avatars/${staffId}/${suffix}`;
  const { error } = await supabase.storage.from(CREW_MEDIA_BUCKET).upload(path, file, { upsert: false, contentType: file.type });
  if (error) throw error;
  return `${CREW_MEDIA_PREFIX}${path}`;
}
